import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import {useRoute} from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'Aside',
  setup(__props) {

const route = useRoute()
const path = route.path
const activeIndex = ref(path)


return (_ctx: any,_cache: any) => {
  const _component_Setting = _resolveComponent("Setting")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_MessageBox = _resolveComponent("MessageBox")!
  const _component_User = _resolveComponent("User")!
  const _component_Notebook = _resolveComponent("Notebook")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!

  return (_openBlock(), _createBlock(_component_el_aside, { width: "200px" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_menu, {
        "default-active": activeIndex.value,
        class: "el-menu-vertical-demo",
        style: {"height":"calc(100vh - 60px)"},
        router: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_menu_item, { index: "/setting" }, {
            title: _withCtx(() => [
              _createTextVNode("仓库设置")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Setting)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/updata" }, {
            title: _withCtx(() => [
              _createTextVNode("更新数据")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_MessageBox)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/users" }, {
            title: _withCtx(() => [
              _createTextVNode("账号列表")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_User)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/logs" }, {
            title: _withCtx(() => [
              _createTextVNode("日志")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Notebook)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["default-active"])
    ]),
    _: 1
  }))
}
}

})